import * as React from 'react';
import * as Convert from 'ansi-to-html';

interface ConsoleViewProps {
  input: string;
}

export class ConsoleView extends React.Component<{ input }, ConsoleViewProps> {

  constructor(props: { input }) {
    super(props);
  }

  public render() {
    // color scheme from terminal.sexy, railscasts (dark)
    // https://terminal.sexy/#Kysr5uHcKysr2kk5pcJh_8ZtbZy-trPrUZ9Q5uHcWmR-2kk5pcJh_8ZtbZy-trPrUZ9Q-ffz
    const { input } = this.props;
    const style = {
      marginTop: '10px',
      paddingLeft: '10px',
      background: '#2B2B2B',
      color: '#E6E1DC',
      fontSize: '15px',
      fontFamily: 'Source Sans 3,sans-serif',
    };
    const converter = new Convert({
      fg: '#E6E1DC',
      bg: '#2B2B2B',
      newline: true,
      escapeXML: false,
      stream: false,
      colors: {
        0: '#2B2B2B',
        1: '#DA4939',
        2: '#A5C261',
        3: '#FFC66D',
        4: '#6D9CBE',
        5: '#B6B3EB',
        6: '#519F50',
        7: '#E6E1DC',
      },
    });
    return (
      <div>
      <pre
        style={style}
        dangerouslySetInnerHTML={{ __html: converter.toHtml(input) }}
      />
      </div>
    );
  }
}
